import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import logoImage from './img/logo.png';
import { fetchUserToken, fetchShoppingCartItems } from '../../redux/actions';
import './decoration.css';

let cartBadge;
class Header extends Component {
  componentDidMount() {
    this.props.fetchUserToken().then(() => {
      this.props.fetchShoppingCartItems(this.props.userToken).then(() => {
        console.log('componentWillMount', this.props.shoppingCartItems);
      });
    });
  }

  render() {
    const { shoppingCartItems, showTopMessage } = this.props;
		const showBottomMessage = false;	// showBottomMessage is a flag to show the bottom message
		// let showBottomMessage = true;
		// const url = window.location.pathname.toLowerCase();
		// const isChineseNewYear = url.indexOf('chinese-new-year') > -1;
		// const isValentines = url.indexOf('valentine') > -1;

		// if(isChineseNewYear || isValentines){
		// 	showBottomMessage = false;
		// }
		if (this.props.shoppingCartItems !== 'Shopping cart is empty!') {
      console.log('render', this.props.shoppingCartItems);
      cartBadge = <div className="cart-badge">{this.props.shoppingCartItems.length }</div>;
    } else {
      cartBadge = undefined;
    }
    return (
			<div className="headerContainer">
				{showTopMessage && (
					<div className="headerMessage">
						<p id="headerMessageText">Enjoy 5% off early bird discount on Mid-Autumn Festival hampers by confirming your orders on or before Sep. 3, 2021.</p>
					</div>
				)}
				<div className="header">
					<span className="col-md-4 col-xs-4" id="left_header_icon">
						<a href="https://www.facebook.com/BorisnMatthew/" target="_blank">
							<i className="fab fa-facebook-f header_icon" />
						</a>
						<a href="https://www.instagram.com/borisnmatthew/" target="_blank">
							<i className="fab fa-instagram header_icon" />
						</a>
					</span>
					<span className="col-md-4 col-xs-4" id="brand_icon">
						<Link to="/">
							<img src={logoImage} alt="LOGO" />
						</Link>
					</span>
					<span className="col-md-4 col-xs-4" id="right_header_icon">
						{ cartBadge }
						<Link to="/order/cartlist">
							<i className="fa fa-shopping-cart header_icon" />
						</Link>
						<Link to="/contact-us">
							<i className="fa fa-comments header_icon" />
						</Link>
					</span>
				</div>

				{showBottomMessage && (
					<div className="headerMessage">
						<p id="headerMessageText">For delivery between Feb. 1 – 15, 2022, there will be price adjustment, staff will re-confirm update price. <br/> (except Chinese New Year & Valentine's Day collections)</p>
					</div>
				)}
			</div>
    );
  }
}
function mapStateToProps(state) {
  return {
    shoppingCartItems: state.shoppingCartItems,
    userToken: state.userToken,
  };
}

export default connect(
  mapStateToProps,
  { fetchUserToken, fetchShoppingCartItems },
)(Header);



// WEBPACK FOOTER //
// ./src/components/decoration/header.js